import type { AnchorTypes } from "@saberhq/anchor-contrib";

import type { TransferWrapperIDL } from "../idls/transfer_wrapper";

export * from "../idls/transfer_wrapper";

export type TransferWrapperTypes = AnchorTypes<
  TransferWrapperIDL,
  {
    transferWrapper: TransferWrapperData;
    transferer: TransfererData;
  }
>;

type Accounts = TransferWrapperTypes["Accounts"];

export type TransferWrapperData = Accounts["TransferWrapper"];
export type TransfererData = Accounts["Transferer"];

export type TransferWrapperError = TransferWrapperTypes["Error"];

export type TransferWrapperProgram = TransferWrapperTypes["Program"];
